import { types } from 'constants/Partner/Transaction';

const initialState = {
    pt: {
        list: {
            loading: false,
            error: '',
            data: [],
            page: 1,
            totalPage: null,
            totalData: 0,
            totalPending: 0,
        },
    },
};

const transaction = (state = initialState.pt, action) => {
    switch (action.type) {
        case types.GET_TRANSACTION_LOADING:
            return {
                ...state,
                list: {
                    ...state.list,
                    loading: true,
                },
            };
        case types.GET_TRANSACTION_SUCCESS:
            return {
                ...state,
                list: {
                    ...state.list,
                    loading: false,
                    data: action.data,
                    totalPage: parseInt(action.totalPage),
                    totalData: parseInt(action.totalData),
                    totalPending: action.totalPending
                        ? parseInt(action.totalPending)
                        : state.list?.totalPending,
                    page: action.page || state.list.page,
                },
            };
        case types.GET_TRANSACTION_FAILED:
            return {
                ...state,
                list: {
                    ...state.list,
                    loading: false,
                    error: action.message,
                },
            };

        default:
            return state;
    }
};

export default transaction;
